import { createAsyncThunk } from "@reduxjs/toolkit";

export const hydratePostsFromCache = createAsyncThunk(
  "posts/hydrateFromCache",
  async () => {
    try {
      const raw = localStorage.getItem("feed_posts_cache");
      if (!raw) return [];
      const arr = JSON.parse(raw);
      return Array.isArray(arr)
        ? arr.map((p) => ({
            ...p,
            timestamp: p?.timestamp ? new Date(p.timestamp) : new Date(),
          }))
        : [];
    } catch {
      return [];
    }
  },
);
